import React from "react"

import Layout from "../components/Layout/layout"
import ContributeComponent from "../components/Contribute/contribute"
import SEO from "../components/seo"

const Contribute = () => (
  <Layout>
    <SEO title="Contribute" />
    <ContributeComponent />
  </Layout>
)

export default Contribute
